import t from "@ext/localization/locale/translate";
import { GlassToolbarButton, GlassToolbarIcon } from "@ui-kit/GlassToolbar";

interface InlineImageActionsProps {
	toBlock: () => void;
}

const InlineImageActions = ({ toBlock }: InlineImageActionsProps) => {
	const tooltip = t("inline-to-block-image");

	return (
		<GlassToolbarButton aria-label={tooltip} onClick={toBlock} tooltipText={tooltip}>
			<GlassToolbarIcon icon="gallery-vertical" />
		</GlassToolbarButton>
	);
};

export default InlineImageActions;
